import React, {useEffect, useState} from "react";
import {Badge, Col, Form, Row} from "react-bootstrap";
import PatientDetailsFieldForm from './PatientDetailsFieldForm';
import {cleanPatientInfo, getPatientStatusStyle, joinWithNewLines} from '../utils';

const componentName = "InsuranceInformation";

/**
 * InsuranceInformation component displays the insurance details of a patient.
 *
 * @param {Object} patientInfo - Object containing the patient's insurance information.
 * @returns {JSX.Element} A section of the patient details view with insurance information.
 */
const InsuranceInformation = ({ patientInfo }) => {
  const {
    payer,
    secondPayer,
    memberId,
    membershipActive,
    termDate,
    originatingOrganization,
    lineOfBusiness,
    valueBasedCare,
    patientQualifyingPrograms
  } = cleanPatientInfo(componentName, patientInfo);

  const payorStatusStyle = getPatientStatusStyle(membershipActive);
  const [newPrograms, setNewPrograms] = useState('');

  useEffect(() => {
    if (patientQualifyingPrograms?.length > 0) {
      setNewPrograms(patientQualifyingPrograms
        .filter(p => p?.programEligibilityStatus === "Active")
        .map(p => p?.programName)
        .join(", ")
      )
    }
  }, [patientQualifyingPrograms])

  return (
    <Form>
      <Row>
        <Col>
          <p className="fs-6 fw-bold">Insurance Information</p>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <PatientDetailsFieldForm elementPrefix="payer" textLabel="PAYOR" textValue={joinWithNewLines(payer, secondPayer)} />
          <PatientDetailsFieldForm elementPrefix="memberId" textLabel="MEMBER ID" textValue={memberId} />
          <PatientDetailsFieldForm elementPrefix="termDate" textLabel="TERM DATE" textValue={termDate} />
          <PatientDetailsFieldForm elementPrefix="practiceName" textLabel="PRACTICE NAME" textValue={originatingOrganization} />
          <PatientDetailsFieldForm elementPrefix="lineOfBusiness" textLabel="LINE OF BUSINESS" textValue={lineOfBusiness} />
          <PatientDetailsFieldForm elementPrefix="qualifyingPrograms" textLabel="QUALIFYING PROGRAMS" textValue={newPrograms} />
          <PatientDetailsFieldForm elementPrefix="valueBasedCare" textLabel="VALUE BASED CARE" textValue={valueBasedCare} />
        </Col>
        <Col>
          <Badge bg="" id={`${componentName}-`} pill style={{ ...payorStatusStyle }}
          >{payorStatusStyle.value}</Badge>
        </Col>
      </Row>
    </Form>
  );
}

export default InsuranceInformation;
